import dayjs from 'dayjs';

export const formatTimestamp = (timestamp: number, template: string) => {
  return dayjs(timestamp).format(template);
};
